import { Svg } from '../common/Svg.js';

export const EquityFocusFlair = function () {
    return (
        <div className="equity-focus-school">
            <span className="tooltip-wrapper nudge-left">
                Equity Focus School
                <Svg icon="help"/>
                <span className="hover-tooltip">
                    At Equity Focus Schools, students have limited access to resources and learning materials.
                    <br/>
                    <a href={baseURL + 'equity-focus'}>Learn more about our Equity Focus</a>
                </span>
            </span>
        </div>
    );
};
